module.exports = __webpack_public_path__ + "img/courier-totalship.ba2ddb0b.svg";